module.exports = __webpack_public_path__ + "img/hr-heated-t-left-1.de3c41f5.png";